import img1 from "../../assets/Images/Banquet Setup/Banquet Setup Portion.png"
import img2 from "../../assets/Images/Banquet Setup/add portion popup.png"

export default function Portions() {
    return (
        <section id="portions" className="space-y-16">

            {/* SECTION TITLE */}
            <section className="bg-white rounded-xl border border-slate-200 p-10">
                <h1 className="text-2xl font-bold text-slate-900 mb-2">
                    1. Portions
                </h1>
                <p className="text-md text-slate-600 max-w-3xl">
                    Portions represent the physical banquet halls or floors where events
                    are hosted. Each portion defines capacity limits and availability
                    during the booking process.
                </p>


                {/* OVERVIEW */}
                <section className="bg-white border-l border-[#C9A24E] p-4 mt-2">
                    <h2 className="text-lg font-semibold mb-3">
                        Overview
                    </h2>
                    <p className="text-slate-600 text-sm">
                        The Portions module allows administrators to define and manage banquet
                        halls such as ground floors, first floors, or separate event spaces.
                        These portions are later used across bookings, estimates, calendars,
                        and reports.
                    </p>
                </section>
            </section>

            {/* PORTION LIST */}
            <section className="">
                <div>
                    <h3 className="font-semibold mb-2">
                        Portion List
                    </h3>

                    <p className="text-slate-600 mb-4">
                        When the Portions module is opened, a list of all configured banquet
                        portions is displayed in a table format.
                    </p>

                    <ul className="list-disc pl-5 text-slate-600 space-y-1">
                        <li>Portion Name</li>
                        <li>Maximum Guest Limit</li>
                        <li>Current Status (Active / Inactive)</li>
                        <li>Action options for management</li>
                    </ul>
                </div>

                <div className=" rounded-lg p-4 mt-4">
                    <img src={img1} alt="" />
                </div>
            </section>

            {/* ADD PORTION */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Adding a New Portion
                </h3>

                <p className="text-slate-600 mb-4">
                    Clicking the <strong>Add Portion</strong> button opens a popup form
                    where new banquet portions can be created.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>
                        <strong>Portion Name:</strong> Name of the hall or floor
                    </li>
                    <li>
                        <strong>Guest Limit:</strong> Maximum number of guests allowed
                        in that portion
                    </li>
                </ul>

                <p className="text-slate-600 mt-4">
                    After entering the required details, clicking the
                    <strong> Save Portion</strong> button stores the portion in the system.
                </p>

                <div className="rounded-lg p-4 mt-4 flex items-center justify-center">
                    <img src={img2} className="w-[400px] h-auto" />
                </div>
            </section>

            {/* STATUS & USAGE */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Status & Usage Rules
                </h3>

                <p className="text-slate-600 mb-3">
                    Portion status determines whether it can be selected during booking.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Active portions appear in booking and estimate forms</li>
                    <li>Inactive portions are hidden from selection</li>
                    <li>Guest limit is enforced during booking</li>
                    <li>Used across Event Calendar and Reports</li>
                </ul>
            </section>

            {/* WHY IMPORTANT */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Why Portions Matter
                </h3>

                <p className="text-slate-600 max-w-3xl">
                    Proper portion configuration prevents overbooking, ensures accurate
                    capacity planning, and keeps event operations aligned with physical
                    space limitations.
                </p>
            </section>

        </section>
    );
}
